// 感度のセレクトボックス選択肢。
// APIは従来通り0〜100の数値を受け付けるが、UI上はこの5段階のみ選択可能とする。
export const SENSITIVITY_OPTIONS = [
  { label: "高い", value: 96 },
  { label: "やや高い", value: 88 },
  { label: "普通", value: 80 },
  { label: "やや低い", value: 72 },
  { label: "低い", value: 64 },
];

// 0〜100の任意値を5択のvalueに丸める（現在値をセレクトボックスの初期値にする用途）。
// Otaria/Namiの段階割り当てに合わせ、64以下（Nami段階1〜8）はすべて「低い」に丸める。
export function toSensitivityOption(value: number): number {
  if (value > 88) return 96;
  if (value > 80) return 88;
  if (value > 72) return 80;
  if (value > 64) return 72;
  return 64;
}

// 0〜100の任意値を表示用ラベルに変換する。
export function sensitivityLabel(value: number | string | null | undefined): string {
  if (value === null || value === undefined || value === "") return "未設定";
  const numericValue = Number(value);
  if (Number.isNaN(numericValue)) return "未設定";
  const option = SENSITIVITY_OPTIONS.find((o) => o.value === toSensitivityOption(numericValue));
  return option ? option.label : "未設定";
}
